module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/home/ariya-metabase/release-2022-02-03/metabase/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/home/ariya-metabase/release-2022-02-03/metabase/frontend/src/metabase/lib/ga-metadata.js"));
    });
  });
}